import { render, staticRenderFns } from "./DelDialog.vue?vue&type=template&id=748e8dc0&"
import script from "./DelDialog.vue?vue&type=script&lang=js&"
export * from "./DelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports